import { PageController } from '@client/components/_core/layout/PageController';
import { ComplianceAuditTemplatePrincipleEdit } from '@client/components/compliance-audit-templates/ComplianceAuditTemplatePrincipleEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: { title: 'Edit principle' },
    },
    params: {
        parse: ({ complianceAuditTemplatePrincipleId }) => ({
            complianceAuditTemplatePrincipleId: BigInt(complianceAuditTemplatePrincipleId),
        }),
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { complianceAuditTemplateId, complianceAuditTemplatePrincipleId } = Route.useParams();

    return (
        <PageController route={Route}>
            <ComplianceAuditTemplatePrincipleEdit
                complianceAuditTemplateId={complianceAuditTemplateId}
                action={['edit', complianceAuditTemplatePrincipleId]}
            />
        </PageController>
    );
}
